module.exports = __webpack_public_path__ + "static/media/8-Devibiz.e583caed.png";